<template>
     <div class="info">
        <div class="label-box">
            <div class="label" @click="isShowLoan=true">
            <div class="lable-left">{{params.lastYear}}年营业收入</div>
            <div class="lable-right">
                <span class="placeholder select-input-arrow" v-if="!loanPlan">请选择</span>
                <span class="select-input-arrow" v-else>{{loanPlan}}</span>
                <span class="iconfont right-icon">&#xe6aa;</span></div>
        </div>
        </div>
        <van-popup v-model="isShowLoan" closeable close-icon-position="top-left" round position="bottom" :style="{ height: '40%' }" :afe-area-inset-bottom="true">
        <van-picker
            :title="`${params.lastYear}年营业收入`"
            cancel-button-text=" "
            show-toolbar
            value-key="name"
            :columns="columns"
            @confirm="loanHandle"
            @cancel="isShowLoan=false"
            />
        </van-popup>
    </div>
</template>
<script>
import { companyDictRevenue } from "@/api/api_company.js"
export default {
     props:{
        params:{
            type:Object,
            required:false,
            default:()=>{
                return {}
            }
        }
    },
    data(){
        return {
            isShowLoan:false,
            columns:[],
            loanPlan:""
        }
    },
    mounted(){
        this.getDictRevenue()
    },
    methods:{
        getDictRevenue(){
            companyDictRevenue().then(res=>{
                if(res.ok===true){
                    this.columns=res.data
                    this.columns.forEach(ele => {
                        if(parseInt(ele.code)===parseInt(this.params.totalRevenue)){
                            this.loanPlan=ele.name
                        }
                    });
                }
            })
        },
        loanHandle(value){
            this.loanPlan=value.name
            this.isShowLoan=false
            this.params.totalRevenue=value.code
            this.$emit('financialInfoForm',this.params)
        },
    }
}
</script>
<style lang="less" scoped>
.right-icon{
    position: absolute;
    right: 0;
}
.select-input-arrow{
    position: absolute;
    left: 0;
    width:125px;
}
/deep/ .van-picker__toolbar{
    margin-top:10px;
}
/deep/ .van-picker__title{ 
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
line-height: 18px;
margin-left: 25px;
}
/deep/ .van-picker__confirm{  
color: #000000;
}
 /deep/ .van-popup__close-icon--top-left{
 top:20px;
}
.finance-box{
    display: flex;
    justify-content: space-between;
    font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(51,51,51,1);
line-height:14px;
padding: 0 20px 26px;
align-items: center;
    .box-right-btn{
        width:57px;
        height:36px;
        background:rgba(248,248,248,1);
        border-radius:3px;
        display: inline-block;
        text-align: center;
        line-height: 36px;
    }
    .active-check{
        background:rgba(235,243,255,1);
        color: #398DFF;
    }
    .space{
        margin-right: 8px;
    }
}
.label-name{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding: 20px 0 37px 20px;
}
.save-btn{
    margin-top:21px;
    text-align: center;
    width:335px;
height:40px;
background:rgba(57,141,255,1);
border-radius:5px;
font-size:16px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:40px;
margin: 21px auto 0;
}
.unit{
    color: @subBlack;
}
.popupTitle{
    font-size:18px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding: 50px 20px 40px;
}
.input-num{
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .symbol{
            margin: 17px 6px 0;
    }
    .input-box{
        .input-year{
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:14px;
            padding-bottom:10px;
        }
        .money{
            span{
                display: inline-block;
                width:59px;
                color: @baseBlue;
            }
        }
        .input-border{
            width:105px;
            height:40px;
            background:rgba(255,255,255,1);
            border-radius:3px;
            border:1px solid rgba(221,221,221,1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px;
            /deep/ .van-cell {
                height: 100%;
                width:90%;
            }
            span{
                font-size:14px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:14px;
            }
        }
        .input-width{
            width:160px;
        }
        .input-border-active{
            border:1px solid rgba(57,141,255,1);
        }
    }
    .input-box:last-child{
        margin-right: 0px;
    } 
}
    .popup-text{
        font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(153,153,153,1);
line-height:16px;
padding:20px;
    }
    .popup-brief{
        font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(57,141,255,1);
line-height:16px;
padding: 0 16px;
    }
    .one-style{
        padding-top:26px;
    }
    .two-style{
padding-top:16px;
    }
    .popup-btn{
        width:335px;
height:40px;
background:rgba(57,141,255,1);
border-radius:5px;
font-size:16px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(255,255,255,1);
line-height:40px;
text-align: center;
margin: -6px auto 0;
    }
    .btn-style{
        border-radius: 20px;
        box-shadow: 0px 5px 10px 0px rgba(57, 141, 255, 0.3);
    }
    .modal-box{
        padding: 20px;
        font-size:14px;
font-family:PingFangSC-Regular,PingFang SC;
font-weight:400;
color:rgba(102,102,102,1);
line-height:24px;
    }
</style>
